'use client';

import React from 'react';
import Link from 'next/link';
import { useSession, signIn } from 'next-auth/react';
import { PiArrowUpRightBold, PiQuestionLight } from 'react-icons/pi';
import { ButtonShadcn } from '@/components/ui/button-shadcn';
import { IconButton } from '@/components/ui/button';
import { UserMenu } from './user-menu';

type HeaderActionsProps = {
  ctaLabel: string;
  ctaHref: string;
  loginLabel?: string;
  helpLabel?: string;
  manageAccountLabel?: string;
  myProgressLabel?: string;
  signOutLabel?: string;
};

export const HeaderActions = ({
  ctaLabel,
  ctaHref,
  loginLabel = 'Login',
  helpLabel = 'Help',
  manageAccountLabel,
  myProgressLabel,
  signOutLabel,
}: HeaderActionsProps) => {
  const { data: session, status } = useSession();
  const isLoading = status === 'loading';
  const isLoggedIn = !!session?.user;

  return (
    <div className='flex items-center gap-4'>
      {!isLoading && !isLoggedIn && (
        <ButtonShadcn asChild variant='blue' size='sm'>
          <Link href={ctaHref} className='flex items-center gap-1'>
            {ctaLabel}
            <PiArrowUpRightBold />
          </Link>
        </ButtonShadcn>
      )}

      {/* <IconButton aria-label={helpLabel} className='hidden sm:flex'>
        <PiQuestionLight size={24} />
      </IconButton> */}

      {!isLoading && !isLoggedIn && (
        <button
          onClick={() => signIn()}
          className='text-base hover:underline bg-transparent border-none cursor-pointer'
        >
          {loginLabel}
        </button>
      )}

      {!isLoading && isLoggedIn && (
        <UserMenu
          manageAccountLabel={manageAccountLabel}
          myProgressLabel={myProgressLabel}
          signOutLabel={signOutLabel}
        />
      )}
    </div>
  );
};
